import { usePost } from '../utils/reactQuery';
import { ApiRoutesEnum } from '../utils/routes';

export const useAddCandidateNote = () => {
  return usePost({
    url: ApiRoutesEnum.candidateAddNote,
  });
};
